export type Details = {
  badge: string;
  title: string;
  accentWord: string;
  subtitle: string;
};

export const EventsPageDetails: Details = {
  badge: 'Comunidade & Cultura',
  title: 'Agenda da Freguesia',
  accentWord: 'Freguesia.',
  subtitle:
    'Participe ativamente na vida da nossa União. Descubra eventos culturais, sessões públicas e atividades para todas as gerações.',
};
